export default __webpack_public_path__ + "static/media/certificate.ed621e26.jpg";